import { render, staticRenderFns } from "./SectionWithIcon.vue?vue&type=template&id=1b9b8874&"
import script from "./SectionWithIcon.vue?vue&type=script&lang=ts&"
export * from "./SectionWithIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports